'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var Serializer = require('../../../types/Serializer.cjs');
var BigNumber = require('../../../types/BigNumber.cjs');

/**
 * The redeemedAmount guard forbids minting when the
 * number of minted NFTs for the entire Candy Machine
 * reaches the configured maximum amount.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const redeemedAmountGuardManifest = {
  name: 'redeemedAmount',
  settingsBytes: 8,
  settingsSerializer: Serializer.mapSerializer(Serializer.createSerializerFromBeet(mplCandyGuard.redeemedAmountBeet), settings => ({
    maximum: BigNumber.toBigNumber(settings.maximum)
  }), settings => settings)
};

exports.redeemedAmountGuardManifest = redeemedAmountGuardManifest;
//# sourceMappingURL=redeemedAmount.cjs.map
